import PropTypes from "prop-types";

/**
 * Renders chart data as a compact table below a chart.
 * Accepts data in { name, value } format (standard chart data shape).
 * Optionally accepts custom column labels via `nameLabel` and `valueLabel`.
 */
export function ChartDataTable({ data, nameLabel, valueLabel, colors }) {
  if (!data || data.length === 0) return null;

  const total = data.reduce((sum, d) => sum + (d.value || d.count || 0), 0);

  return (
    <div className="chart-data-table">
      <table className="chart-data-table__table">
        <thead>
          <tr>
            <th className="chart-data-table__th">{nameLabel || "Name"}</th>
            <th className="chart-data-table__th chart-data-table__th--center">{valueLabel || "Count"}</th>
            <th className="chart-data-table__th chart-data-table__th--right">%</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => {
            const val = item.value ?? item.count ?? 0;
            const pct = total > 0 ? ((val / total) * 100).toFixed(1) : "0.0";
            return (
              <tr key={item.name || idx} className="chart-data-table__row">
                <td className="chart-data-table__td">
                  {colors && (
                    <span className="chart-data-table__dot" style={{ background: colors[idx % colors.length] }} />
                  )}
                  {item.name}
                </td>
                <td className="chart-data-table__td chart-data-table__td--center">{val.toLocaleString()}</td>
                <td className="chart-data-table__td chart-data-table__td--right chart-data-table__td--muted">{pct}%</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="chart-data-table__total">
            <td className="chart-data-table__td">Total</td>
            <td className="chart-data-table__td chart-data-table__td--center">{total.toLocaleString()}</td>
            <td className="chart-data-table__td chart-data-table__td--right">100%</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

ChartDataTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
      count: PropTypes.number,
    })
  ).isRequired,
  nameLabel: PropTypes.string,
  valueLabel: PropTypes.string,
  colors: PropTypes.array,
};

export default ChartDataTable;
